// Next
import Script from "next/script";

const CookieBanner = () => {
    return <Script id={"cookie-banner-script"} src={"https://cdn.userdatatrust.com/483416160S.js"} type="text/javascript" strategy={"beforeInteractive"}/>
};

export default CookieBanner;
